import { install } from '@qcolor/utils/compoent';
import ColorSketch from './color-sketch.vue';
ColorSketch.install = install;
export default ColorSketch;